export var QUERY_LIST_TYPE;
(function (QUERY_LIST_TYPE) {
    QUERY_LIST_TYPE["multiple"] = "multiple";
    QUERY_LIST_TYPE["join"] = "join";
})(QUERY_LIST_TYPE || (QUERY_LIST_TYPE = {}));
var HttpQuery = /** @class */ (function () {
    function HttpQuery(queryBuilder, config) {
        this.queryBuilder = queryBuilder;
        this.config = config;
    }
    HttpQuery.prototype.toString = function (payload) {
        var _this = this;
        var params = this.queryBuilder(payload);
        return Object.keys(params)
            .reduce(function (acc, key) {
            var _a;
            var value = params[key];
            if (value === undefined) {
                return acc;
            }
            if (Array.isArray(value) && ((_a = _this.config) === null || _a === void 0 ? void 0 : _a.listType) === QUERY_LIST_TYPE.multiple) {
                value
                    .filter(function (v) { return v !== undefined; })
                    .forEach(function (v) {
                    acc += "&" + key + "=" + encodeURIComponent(String(v));
                });
                return acc;
            }
            acc += "&" + key + "=" + encodeURIComponent(String(value));
            return acc;
        }, '')
            .replace(/^&+/, '');
    };
    return HttpQuery;
}());
export { HttpQuery };
//# sourceMappingURL=HttpQuery.js.map